import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructDelete } from '../../../types/ConstructDelete';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const deleteResetApplicationAssignUser = async (
  constructDelete: ConstructDelete,
  uuid: string,
  definitionName: string,
): Promise<NonPaginatedResponse<any> | undefined> =>
  constructDelete(
    `${APPLICATION_BASE_PATH}/${uuid}/assignments/destroy`,
    {
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
